export const styles = {
	sideBar: {
		display: { xs: 'none', sm: 'block' },
		minWidth: '4px',
		background: 'linear-gradient(180deg, #E65C00 0%, #F9D423 100%)',
	},
	columnBox: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		width: '100%',
	},
	container: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: '1',
		gap: '1rem',
		width: '50%',
	},
	dropdownContainer: {
		display: 'flex',
		gap: '32px',
		marginTop: '8px',
		flexDirection: {
			lg: 'row',
			md: 'row',
			sm: 'column',
			xs: 'column',
		},
	},
	exampleIdeasBox: {
		padding: '1rem',
		backgroundColor: '#FFE9C9',
		color: 'black',
	},
	innerColumn: {
		display: 'flex',
		flexDirection: 'column',
		rowGap: '3rem',
		flexGrow: '1',
	},
	headerBox: {
		flexDirection: {
			lg: 'row',
			md: 'row',
			sm: 'row',
			xs: 'column',
		},
		alignItems: {
			lg: 'center',
			md: 'center',
			sm: 'center',
			xs: 'flex-start',
		},
	},
	listItem: {
		margin: '10px 0',
	},
	radioButton: {
		color: '#999999',
		'&.Mui-checked': {
			color: '#FFC876',
		},
	},
	radioGroup: {
		alignItems: 'center',
		gap: '1rem',
		color: '#274A62',
		fontSize: '1.4rem',
		fontWeight: 500,
	},
	editButtonsContainer: {
		display: 'flex',
		flexDirection: { xs: 'column', sm: 'row' },
		gap: '2rem',
	},
	rightAlign: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	unsureText: {
		fontSize: '1.8rem',
		color: '#000000DE',
	},
}
